var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10283 3.7207H14.894C15.8271 3.7207 16.5906 4.48416 16.5906 5.41728V13.6033C16.5906 14.5364 15.8271 15.2998 14.894 15.2998H3.10283C2.16971 15.2998 1.40625 14.5364 1.40625 13.6033V5.41728C1.40625 4.48416 2.16971 3.7207 3.10283 3.7207ZM2.21212 6.60488H15.7847V5.41728C15.7847 4.95072 15.3606 4.52658 14.894 4.52658H3.10283C2.63627 4.52658 2.21212 4.95072 2.21212 5.41728V6.60488ZM15.7847 8.51353H2.21212V13.6033C2.21212 14.1122 2.63627 14.494 3.10283 14.494H14.894C15.3606 14.494 15.7847 14.1122 15.7847 13.6033V8.51353Z",
    fill: "#464646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16298 11.3117C3.95091 11.3117 3.78125 11.1421 3.78125 10.93C3.78125 10.6755 3.95091 10.5059 4.16298 10.5059H7.7682C7.98028 10.5059 8.19235 10.6755 8.19235 10.93C8.19235 11.1421 7.98028 11.3117 7.7682 11.3117H4.16298Z",
    fill: "#464646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16298 13.1354C3.95091 13.1354 3.78125 12.9233 3.78125 12.7113C3.78125 12.4992 3.95091 12.2871 4.16298 12.2871H6.66543C6.8775 12.2871 7.08957 12.4992 7.08957 12.7113C7.08957 12.9233 6.8775 13.1354 6.66543 13.1354H4.16298Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionPayment);
export default __webpack_public_path__ + "static/media/subscriptionPayment.4101dd6d64a8f1cd403296c8b53b2ea8.svg";
export { ForwardRef as ReactComponent };